export class ApprovedFileExtension {
  tenantId: string;
  fileExtension: string;
}
